import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
// import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import {getDateFormat} from '../../Utils/UserFunctions';
import {isSet} from '../../Utils/CommonFunctions';
import Wrp from "../../hoc/Wrp/Wrp";
import MomentUtils from '@date-io/moment';
import {
  TimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
// cyan lightBlue
import blue from "@material-ui/core/colors/blue";

class TimePick extends Component {

  fieldOnChangeHandler = (moment)=>{
    const {changeHandler,attributes} = this.props;
    if (isSet(moment,null)!==null &&  typeof moment.format === "function") {
        const  systemFormat =  moment.format((isSet(attributes.putDateFormat,null)!==null)?attributes.putDateFormat:'YYYY-MM-DDTHH:MM:ss');
        //moment.format('YYYY-MM-DDTHH:MM:ss'); //2021-02-28T23:55:15
        // console.log(systemFormat);
        changeHandler(systemFormat);
    }else{
      changeHandler(null);
    }
  } 

  render() {
    const {value} = this.props;
    let attr = setAndGetAttributes(this.props);
    const dateFormat = (attr.getDateFormat!==undefined)?attr.getDateFormat:'hh:mm A';
    let dispValue = '';
    if(dateFormat==='UNIX'){
      dispValue = (value!=='' && value!==undefined)?moment(value).format('hh:mm A'):'';
    }else{
      dispValue = (value!=='' && value!==undefined)?moment(value, dateFormat, true).format('hh:mm A'):'';
    }
    const materialTheme = createTheme({
      palette: {
        primary: blue,
      },
    });
    return (
      <Wrp>
        <ThemeProvider theme={materialTheme}>
            <MuiPickersUtilsProvider utils={MomentUtils} >
              <TimePicker
                fullWidth
                keyboard
                clearable
                // margin="normal"
                value={(isSet(dispValue,null)!==null)?moment(dispValue, 'hh:mm A', true):null}//this.state.selectedDate}//attr.value}
                // disablePast
                onChange={this.fieldOnChangeHandler}
                label=""
                // clearable={true}
                InputProps={{
                  className:'form-control',
                  style: {fontSize: '0.8rem',borderTopLeftRadius:'0px',borderBottomLeftRadius:'0px',paddingLeft:'4px'},
                  disableUnderline: true,
                  ...attr,
                  autoComplete:'off',
                }}
                // readOnly={readonlyVal} 
                //  variant={'inline'}       
                // showTodayButton 
                format={'hh:mm A'}
                />
              </MuiPickersUtilsProvider>
                </ThemeProvider>
        {/* <Datetime
            closeOnSelect={true}
            value={dispValue}
            inputProps={{...attr,autoComplete:'off'}}
            onChange={this.fieldOnChangeHandler}
            dateFormat= {getDateFormat()}
            timeFormat={false}
        /> */}
      </Wrp>        
    );
  }
}

TimePick.defaultProps = {
  isMandatory:false,
  className: 'form-control'
}

export default TimePick;